import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { ArrowLeftOutlined, GlobalOutlined, UserOutlined, LogoutOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { PATH } from '../../routes/Routes';
import { useTranslation } from 'react-i18next';
import ConfirmModal from './ConfirmModal';
import { useUserContext } from '../../hooks/UserSettingProvider';

const { Header } = Layout;

function SubHeader(props) {
  const { showConfirmMovingPage } = props;
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(null);
  const { user, onLogout } = useUserContext();
  const [confirmMovePageVisible, setConfirmMovePageVisible] = useState(null);
  const [menuTheme] = useState('dark');


  React.useEffect(() => {
    if (localStorage.getItem('i18nextLng')) {
      setLanguage(localStorage.getItem('i18nextLng'));
    }
  }, []);

  React.useEffect(() => {
    if (language && (language != i18n.language)) {
      i18n.changeLanguage(language.toLocaleLowerCase());
    }
  }, [language]);

  const handleLogout = () => {
    onLogout();
    history.replace(PATH.LOGIN)
  }

  const actionMovePage = (action) => {
    if (action === 'back') {
      history.goBack();
    } else if (action === 'profile') {
      history.replace(PATH.USER_PROFILE);
    }
  };

  const iconStyle = {
    margin: '3px',
    fontSize: '20px',
    cursor: 'pointer',
  };

  const headerStyle = {
    zIndex: 1000,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    padding: 0
  };

  return (
    <div>
      <Header className="Sub-header" style={headerStyle}>
        <ConfirmModal
          open={confirmMovePageVisible != null}
          onClose={() => setConfirmMovePageVisible(null)}
          title={t('confirms.move_page_title')}
          content={t('confirms.move_page_content')}
          onConfirm={() => {
            actionMovePage(confirmMovePageVisible);
            setConfirmMovePageVisible(null);
          }}
        />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Menu mode="horizontal" theme={menuTheme} selectable={false}>
            <Menu.Item
              inverted
              onClick={() => {
                if (showConfirmMovingPage) {
                  setConfirmMovePageVisible('back');
                } else {
                  history.goBack();
                }
              }}
              title="Back"
            >
              <ArrowLeftOutlined style={iconStyle} />
            </Menu.Item>
          </Menu>

          <Menu
            mode="horizontal"
            theme={menuTheme}
            selectable={false}
            style={{ fontWeight: 'bold' }}
          >
            <Menu.SubMenu
              key="language"
              title={
                <span>
                  <GlobalOutlined style={iconStyle} />
                  {language ? language.toUpperCase() : 'EN'}
                </span>
              }
              theme="light"
            >
              <Menu.Item key="th" onClick={() => setLanguage('th')}>
                TH
              </Menu.Item>
              <Menu.Item key="en" onClick={() => setLanguage('en')}>
                EN
              </Menu.Item>
            </Menu.SubMenu>

            <Menu.SubMenu
              key="user"
              icon={<UserOutlined style={iconStyle} />}
              theme="light"
            >
              <Menu.Item>{user.display_name}</Menu.Item>
              <Menu.Divider />
              <Menu.Item
                key="profile"
                onClick={() => {
                  if (showConfirmMovingPage) {
                    setConfirmMovePageVisible('profile');
                  } else {
                    history.replace(PATH.USER_PROFILE);
                  }
                }}
              >
                <UserOutlined /> {t('menus.user_profile')}
              </Menu.Item>
              <Menu.Item key="logout" onClick={handleLogout}>
                <LogoutOutlined /> {t('menus.log_out')}
              </Menu.Item>
            </Menu.SubMenu>
          </Menu>
        </div>
      </Header>
      <Header/>
    </div>
  );
};

export default SubHeader;
